import { render, staticRenderFns } from "./NewContract.vue?vue&type=template&id=a67f11c4&scoped=true"
import script from "./NewContract.vue?vue&type=script&lang=ts"
export * from "./NewContract.vue?vue&type=script&lang=ts"
import style0 from "./NewContract.vue?vue&type=style&index=0&id=a67f11c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67f11c4",
  null
  
)

export default component.exports